import { Divider, Typography } from '@mui/material';
import { LP_REALISATION_LIST } from 'adminConstants/routes';
import Page from 'components/new/Page';
import TransactionAllocator from 'components/TransactionAllocator';
import { useLayoutContext } from 'contexts/LayoutContext';
import { CalendarDay } from 'further-ui/utils';
import { Column } from 'further-ui/components/Layout';
import StaticField from 'further-ui/components/StaticField';
import useTransactionTypeSelectorOptions from 'hooks/form/useTransactionTypeSelectorOptions';
import api from 'lib/trpcClient';
import React from 'react';
import { useParams } from 'react-router-dom';

const ViewRealisationReversalPage: React.FC<{ vehicleId: string }> = ({
  vehicleId,
}) => {
  const { actionId } = useParams<{ actionId: string }>();
  const { transactionTypeOptions } = useTransactionTypeSelectorOptions();
  const { vehicle } = useLayoutContext();

  const [existingReversal] = api.lpReversal.getReversal.useSuspenseQuery({
    vehicleId,
    actionId: actionId ?? '',
  });

  const reversalLedgerDate = existingReversal
    ? existingReversal.ledgerDate
    : new CalendarDay(new Date());

  const [realisationTransactions] =
    api.lpReversal.getRealisationTransactions.useSuspenseQuery({
      vehicleId,
      actionId: actionId ?? '',
      reversalDate: reversalLedgerDate,
    });

  const [realisation] = api.lpRealisation.get.useSuspenseQuery({
    realisationId: actionId ?? '',
    vehicleId,
  });

  const tcyTransactionCurrency = vehicle
    ? realisationTransactions?.find(
        (t) => t.transactionCurrency !== vehicle.baseCurrency,
      )?.transactionCurrency
    : undefined;

  const forceShowTcy =
    !!vehicle &&
    !!realisation &&
    (realisation.currencyCode !== vehicle.baseCurrency ||
      !!tcyTransactionCurrency);

  const transactionCurrency =
    tcyTransactionCurrency ??
    realisation?.currencyCode ??
    vehicle?.baseCurrency;

  const fxRate = realisation?.currencyRate ?? null;

  return (
    <Page
      tabTitle="View Realisation Reversal"
      spacing="lg"
      heading="View Realisation Reversal"
      withHeadingDivider
      goBackAction={LP_REALISATION_LIST}
    >
      <Column spacing="lg">
        <StaticField label="Reversal date">
          {reversalLedgerDate.toReadable()}
        </StaticField>

        <Divider />

        <Typography variant="h6">Account transactions</Typography>

        {vehicle && (
          <TransactionAllocator
            readOnly
            transactions={realisationTransactions}
            transactionTypeOptions={transactionTypeOptions}
            transactionCurrency={transactionCurrency}
            vehicle={{
              _id: vehicleId,
              baseCurrency: vehicle.baseCurrency,
              fxDataFeed: vehicle.fxDataFeed,
            }}
            fxRate={fxRate}
            forceShowTcy={forceShowTcy}
          />
        )}
      </Column>
    </Page>
  );
};

export default ViewRealisationReversalPage;
